import React from 'react'
import i1 from './photolic/dahan.jpg'
import './image.css'
const Dahan = () => {
  return (
    <div>
       <img src={i1} alt="" className='eimg' />
    </div>
  )
}

export default Dahan
